var smartLeveling = (function(self){
        var SAVE_KEY_SUFFIX = "_lvl", progression = {};
        self.wrong = self.good = self.roundWrong = self.roundGood = 0;
        self.ratio = -1;

        self.reset = function(ratio)
        {
            self.ratio = ratio === null ? -1 : ratio;
            self.wrong = self.good = 0;
            self.roundWrong = self.roundGood = 0;
        };

        self.incrementWrong = function()
        {
            self.wrong ++;
            self.roundWrong ++;
        };
        self.incrementGood = function()
        {
            self.good ++;
        };
        self.canLevelUp = function()
        {
            return self.wrong === 0 || (self.good / self.wrong) > self.ratio;
        };
        self.getSavedLevel= function(pScreen)
        {
            return parseInt(progression[pScreen+SAVE_KEY_SUFFIX]) || 0;
        };
        self.saveLevel = function(pScreen,currentLevel)
        {
            progression[pScreen+SAVE_KEY_SUFFIX] = String(currentLevel);
        };

        return self;
    }(smartLeveling = smartLeveling || {}));
